
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

// MANTINE IMPORTS
import "@mantine/carousel/styles.css";
import {
  createTheme as createMantineTheme,
  MantineProvider,
} from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

import { Notifications } from "@mantine/notifications";

import Login from "./Pages/Login";
import SignUp from "./Pages/SignUp";
import Wrapper from "./Pages/Wrapper";
import Services from "./Pages/Services";
import MySubscriptions from "./Pages/MySubscriptions";
import SingleSubscriptionPage from "./Pages/SingleSubscription";
import MyTransactions from "./Pages/Transactions";
import SupportPage from "./Pages/Support";
import RegisterYoutube from "./Pages/RegisterYoutube";
import NotFound404 from "./Pages/404NotFound";
import AccountDeleted from "./Pages/AccountDeleted";
import Benefits from "./Pages/Blog/Benefits";
import ForgotPassword from "./Pages/ForgotPassword";
import HomePage from "./Pages/Home";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import RequestDelete from "./Pages/RequestDelete";
import ResetPassword from "./Pages/ResetPassword";
import TermsAndConditions from "./Pages/TermsAndConditions";
import VerifyEmailPage from "./Pages/VerifyEmail";
import PromoterScreen from "./Pages/Promoter";
import CreateSupport from "./Pages/CreateSupport";
import SingleSupport from "./Pages/SingleSupport";
import ProfilePage from "./Pages/Profile";
import LoginFromAdmin from "./Pages/LoginFromAdmin";
import SuccessfulPayment from "./Pages/Payment/Success";
import "./styles/index.scss";
const mantineTheme = createMantineTheme({});
const router = createBrowserRouter([
  {
    path: "*",
    // element: <CountdownPage />,
    element: <NotFound404 />,
  },
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/delete/:email",
    element: <RequestDelete />,
  },
  {
    path: "/c_d_u/:verificationToken",
    element: <AccountDeleted />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <TermsAndConditions />,
  },
  {
    path: "/sign-up",
    element: <SignUp />,
  },
  {
    path: "/v/:verificationID/:verificationToken",
    element: <VerifyEmailPage />,
  },
  {
    path: "/r",
    element: <ForgotPassword />,
  },
  {
    path: "/r/:verificationToken",
    element: <ResetPassword />,
  },
  {
    path: "/blog/benefits",
    element: <Benefits />,
  },
  {
    path: "/d",
    element: <Wrapper />,
    children: [
      {
        index: true,
        element: <Navigate to="services" replace />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "transactions",
        element: <MyTransactions />,
      },
      {
        path: "youtube/:tempID",
        element: <RegisterYoutube />,
      },
      {
        path: "subscriptions",
        element: <MySubscriptions />,
      },
      {
        path: "subscriptions/:subscriptionID",
        element: <SingleSubscriptionPage />,
      },
      {
        path: "support",
        element: <SupportPage />,
      },
      {
        path: "support/new",
        element: <CreateSupport />,
      },
      {
        path: "support/view/:ticketID",
        element: <SingleSupport />,
      },
      {
        path: "promoter",
        element: <PromoterScreen />,
      },
      {
        path: "profile",
        element: <ProfilePage />,
      },
      {
        path: "a/:userToken",
        element: <LoginFromAdmin />,
      },
    ],
  },
  {
    path: "/payment/*",
    element: <Wrapper />,
    children: [
      {
        path: "success",
        element: <SuccessfulPayment />,
      },
    ],
  },
]);

export default function App() {
  return (
    <MantineProvider theme={mantineTheme}>
      <Notifications
        styles={{
          root: {
            zIndex: 9999999999999,
          },
        }}
        position="bottom-right"
      />
      <RouterProvider router={router} />
    </MantineProvider>
  );
}
